
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const EmptyState = () => {
  return (
    <Card className="p-6 text-center bg-gray-50">
      <p className="text-gray-600 mb-4">You haven't followed any strategies yet.</p>
      <Button className="bg-[#607D9B] hover:bg-[#4A607B]" asChild>
        <Link to="/marketplace">Explore Strategies</Link>
      </Button>
    </Card>
  );
};

export default EmptyState;
